import React from 'react';
import { useTranslation } from 'react-i18next';
import { isAndroid, isIOS } from 'react-device-detect';

const MobileModal = () => {
    const { t } = useTranslation();

    // В ProItem передаем класс иконки вместо цвета/SVG
    const ProItem = ({ title, description, iconClass, divider = true }) => (
        <div className="pro-item">
            <div className="pro-item__row">
                <div className="pro-item__icon-box">
                    <div className={`pro-item__icon ${iconClass}`}></div>
                </div>

                <div className="pro-item__text-box">
                    <div className="pro-item__title">{title}</div>
                    <div className="pro-item__desc">{description}</div>
                </div>
            </div>
            {divider && <div className="pro-item__divider"></div>}
        </div>
    );

    return (
        <section className="mobile-paywall">
            <div className="mobile-paywall__wrapper">

                {/* 1. ЗАГОЛОВОК */}
                <div className="mobile-paywall__header">
                    <h1 className="mobile-paywall__app-name">{t('translate.app_name2')}</h1>
                    <span className="mobile-paywall__subtitle">{t('translate.formuls_title')}</span>
                </div>

                {/* 2. ИКОНКА ПРИЛОЖЕНИЯ (через CSS) */}
                <div className="mobile-paywall__icon-wrapper">
                    <div className="mobile-paywall__app-icon"></div>
                </div>

                {/* 3. КНОПКА ЗАГРУЗКИ (Бейджики через CSS) */}
                <div className="mobile-paywall__store-link">
                    {isIOS ? (
                        <a href="#" className="store-badge store-badge--ios" aria-label="Download on App Store"></a>
                    ) : (
                        <a href="https://play.google.com/store/apps/details?id=august.fizika" className="store-badge store-badge--android" aria-label="Get it on Google Play"></a>
                    )}
                </div>

                {/* 4. СПИСОК ФИЧ */}
                <div className="mobile-paywall__features">
                    <ProItem
                        title={t('translate.premium_list1_title')}
                        description={t('translate.premium_list1_subtitle')}
                        iconClass="pro-item__icon--1"
                    />
                    <ProItem
                        title={t('translate.premium_list2_title')}
                        description={t('translate.premium_list2_subtitle')}
                        iconClass="pro-item__icon--2"
                    />
                    <ProItem
                        title={t('translate.premium_list3_title')}
                        description={t('translate.premium_list3_subtitle')}
                        iconClass="pro-item__icon--3"
                        divider={false}
                    />
                </div>

            </div>
        </section>
    );
};

export default MobileModal;